import React, { FC, HTMLAttributes, useEffect, useState } from 'react';
import { useDispatchRequest, useQuery } from '@redux-requests/react';
import classNames from 'classnames';
import { AppsConstants } from '../store/constants';
import { Heading } from 'components/ui';
import WebhookLog from './components/WebhookLog/WebhookLog';
import AsideContainer from './components/AsideContainer/AsideContainer';
import styles from './WebhookLogs.module.scss';
import { InfiniteScroll, InfiniteScrollLoader, NoResults, Widget } from 'components';
// import { getAppHooksLogsStatistics } from 'modules/userApps/store/actions/getAppHooksLogsStatistics';
import { getAppHooksLogs } from 'modules/userApps/store/actions/getAppHooksLogs';
import { t } from 'utils';

export interface IWebhookLogs extends HTMLAttributes<HTMLDivElement> {
  id: string;
}

const limit = 20; // number of hooks per request

const WebhookLogs: FC<IWebhookLogs> = (props) => {
  const { id, className } = props;
  const [hooksPage, setHooksPage] = useState(1);
  const dispatch = useDispatchRequest();
  const {
    data: { webHookLogs, successRatioStatistics, hooks, hasMoreLogs },
  } = useQuery({ type: AppsConstants.APP, requestKey: id });
  const hasNoWebhooks = !hooks.length;
  const hasNoWebhooksLogs = !webHookLogs?.length;
  // useEffect(() => {
  //   !hasNoWebhooks &&
  //     dispatch(getAppHooksLogsStatistics(id, 'WEBHOOK_SUCCESS_RATIO_STATISTICS')).catch((e) =>
  //       console.error(e)
  //     );
  // }, [dispatch, id, hasNoWebhooks]);
  useEffect(() => {
    !hasNoWebhooks &&
      hasMoreLogs &&
      dispatch(getAppHooksLogs(id, { limit, page: hooksPage })).catch((e) => console.error(e));
  }, [dispatch, hooksPage, hasNoWebhooks, id, hasMoreLogs]);
  const rootClassName = classNames(styles.root, className);
  const { failureCount, successCount } = successRatioStatistics || {};

  return (
    <div className={rootClassName}>
      <div className={styles.col}>
        <Heading className='mb-2' icon='bullhorn'>
          {t('app.webhooks')}
        </Heading>
        {!hasNoWebhooksLogs ? (
          <InfiniteScroll
            dataLength={webHookLogs?.length}
            next={() => setHooksPage(hooksPage + 1)}
            hasMore={hasMoreLogs}
            loader={<InfiniteScrollLoader />}
          >
            {webHookLogs?.map((webHookLog: any) => (
              <WebhookLog {...webHookLog} className={styles.item} key={webHookLog.id} />
            ))}
          </InfiniteScroll>
        ) : (
          <NoResults>{t('global.noResults')}</NoResults>
        )}
      </div>
      <div className={styles.sideCol}>
        <AsideContainer title={t('app.webhooks')} description={t('app.webhooks.aside.hintText')}>
          <Widget data={failureCount || 0} title='app.webhoooks.failedEvents' />
          <Widget data={successCount || 0} title='app.webhoooks.successfulEvents' />
        </AsideContainer>
      </div>
    </div>
  );
};

export default WebhookLogs;
